import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getsJoomlaMenu } from "../../actions/menu";
// import menuIcon from '../images/menu-icon.svg';
// import logo from '../images/logo.png';
// import JoomlaOffcanvasMenu from "./joomlaOffcanvasMenu";
// import WishBar from "./wishCartCompareBar";
// import Menu from "./menu";
// import i18n from "i18next";
// import {withRouter} from 'react-router-dom';
import { config } from "../../config";
// import catalogIcon from "../images/catalog-icon.svg";
// import MobMenu from "./mobMenu";
// import FlagUa from "../images/flag-ua.png";
// import FlagRu from "../images/flag-ru.png";
import loader from "../../images/loader.svg";
class TopMenu extends Component {
  static props = {
    joomlaMenu: PropTypes.array,
    isShowLoaderMenu: PropTypes.bool,
  };

  componentDidMount() {
    this.props.getsJoomlaMenu('menu-desktop-' + this.props.i18n.language);
  }
  subMenu = parentId => {

    const subMenuList = this.props.joomlaMenu.joomla.filter(val => {
      return val.parentId == parentId
    })
    if (subMenuList.length) {
      const list = <div className="uk-navbar-dropdown menu-dropdown uk-box-shadow-large uk-dropdown" uk-dropdown="pos: bottom-left">
        <ul className="uk-nav uk-navbar-dropdown-nav">
          {Object.keys(subMenuList).map((id, inx) => {
            return (
              <li >
                <a
                  className="header-nav__link"
                  href={config.siteUrl + subMenuList[inx].path}
                >
                  {subMenuList[inx].title}
                </a>
              </li>
            )
          })
          }
        </ul>
      </div>

      return list;
    }

  }

  render() {
    
    return (
      <div className="header-top-nav uk-position-relative">
        <ul className="uk-navbar-nav menu">
          {this.props.isShowLoaderMenu === false ? (
            Object.keys(this.props.joomlaMenu.joomla).map((itm, key) => (
              this.props.joomlaMenu.joomla[itm].level === 1 &&
              <li key={"jom-menu-" + itm}>
                <a
                  href={
                    config.siteUrl + this.props.joomlaMenu.joomla[itm].alias
                  }
                >
                  {this.props.joomlaMenu.joomla[itm].title}
                </a>
                {this.subMenu(this.props.joomlaMenu.joomla[itm].id)}
              </li>
            ))
          ) : (
            <li>
              <div className="loader-overlay  uk-position-z-index">
                <div className="uk-position-center">
                  <img
                    className="header-top-nav__loader-img"
                    src={loader}
                    uk-svg={""}
                    alt={"loading..."}
                  />
                </div>
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { joomlaMenu, isShowLoaderMenu } = store.menu;
  return { joomlaMenu, isShowLoaderMenu };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getsJoomlaMenu: (menutype) => {
      dispatch(getsJoomlaMenu(menutype));
    },
  };
};

const TopNavMenu = withTranslation("translations")(TopMenu);

export default connect(mapStateToProps, mapDispatchToProps)(TopNavMenu);
